<div class="main">
    <div class="container-fluid">
        <div class="evaluations-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="evaluations-title-container mb-3 mb-md-0">
                <h3>Evaluations</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="evaluations-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>Evaluations</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3">
                <!-- Only Secretary can see/click this -->
                <button 
                    *ngIf="isSecretary()"
                    class="btn action-btn-purple d-flex align-items-center gap-2"
                    (click)="navigateToAssignEvaluators()" 
                    aria-label="Assign Evaluations">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M10 4V16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 10H16" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Assign Evaluations</span>
                </button>
                <button class="upload-btn rounded-pill text-white" (click)="uploadEvaluations()" aria-label="Upload evaluations">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M10 2.5V13.75M10 2.5L6.25 6.25M10 2.5L13.75 6.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.5 13.75V16.25C2.5 17.0784 3.17157 17.75 4 17.75H16C16.8284 17.75 17.5 17.0784 17.5 16.25V13.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <app-data-table
            [data]="evaluations"
            [columns]="tableColumns"
            [paginator]="true"
            [rows]="10"
            (onActionClick)="onTableActionClick($event)"
            (onLinkClick)="onTableLinkClick($event)">
        </app-data-table>
    </div>
</div>

